 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Account No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAcctNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs6>
                          <v-text-field
                            data-vv-scope="queryAcctNoFilterForm"
                            v-model="filtersAcctNo.accountNo"
                            :label="filtersAcctNoLabel.accountNo"
                            :error-messages="errors.collect('accountNo')"
                            data-vv-name="accountNo"
                            :data-vv-as="filtersAcctNoLabel.accountNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <v-text-field
                            data-vv-scope="queryAcctNoFilterForm"
                            v-model="filtersAcctNo.accountName"
                            :label="filtersAcctNoLabel.accountName"
                            :error-messages="errors.collect('accountName')"
                            data-vv-name="accountName"
                            :data-vv-as="filtersAcctNoLabel.accountName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearAcctNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doAcctNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="acctNoHeaders"
          :items="acctNoItems"
          v-bind:options.sync="paginationAcctNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsAcctNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.name }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'

export default {
  data() {
    return {
      filtersAcctNoLabel: {
        accountNo: 'Account No.',
        accountName: 'Name'
      },
      filtersAcctNo: {
        accountNo: undefined,
        accountName: undefined
      },
      acctNoItems: [],
      totalItemsAcctNo: 0,
      acctNoHeaders: [
        { text: 'Account No.', align: 'left', value: 'accountNo' },
        { text: 'Name', value: 'intermediaryName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAcctNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearAcctNoFilters()
      }
    },
    'paginationAcctNo': function (value) {
      this.doClearAcctNoFilters()
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearAcctNoFilters() {
      this.resetFilterForm()
      this.fetchAcctNoData()
    },
    doAcctNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAcctNoFilterForm').then((result) => {
        if (result) {
          this.paginationAcctNo.page = 1
          this.fetchAcctNoData()
        }
      })
    },
    assignAcctNo(data) {
      // Use $emit to call parent Accounts page method assignAcctNo and pass the value
      this.$emit('assign-acct-info', data)
      this.$emit('assign-acct-no', data.inter)
      this.$emit('close')
    },
    resetFilterForm() {
      this.filtersAcctNo.accountNo = ''
      this.filtersAcctNo.accountName = ''
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, accountsFilters]
}
</script>
